<template>
  <modal :show.sync="showModal" size="lg">
    <h6 slot="header" class="modal-title">Editar Venta: #{{fetchVenta.id}}</h6>
    <form class="needs-validation" id="formEditVenta"
        @keyup.enter="eventoEnter($event)"
        @submit.prevent="sendForm($event)">
      <!--<h2>Atributos del Plan</h2>-->
      <!--
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      placeholder="Ingrese un nombre"
                      name="nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="model.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Categoria"
                      name="categoria"
                      :error="getError('categoria')"
                      v-validate="'required'"
                      v-model="model.category.value"
                >
                    <el-select  v-model="model.category.value" filterable
                                placeholder="Seleccione categoría"
                                
                                >
                        <el-option v-for="option in selectCategories"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
            <card>
                <div class="row ">
                    <div class="col col-md-6 d-flex justify-content-center">
                        <base-input label="Asociar campos:" >
                            <el-select :disabled="!abilityEditSearchableattributes" @change="refreshFeatures"  v-model="chosenFields" multiple collapse-tags
                                        placeholder="Seleccione los campos">
                                <el-option v-for="option in selectSearchablesAttributes"
                                            :key="option.label"
                                            :label="option.label"
                                            :value="option.value">
                                </el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col col-md-6 d-flex align-content-center flex-wrap">
                        <button class=" btn btn-default" type="button" @click="abrirModalCreateSearchableAtribute"><i class="ni ni-curved-next"></i> Crear campo</button>
                    </div>
                </div>
                <div class="row">
                  <div class="container">
                    <p v-if="!abilityEditSearchableattributes" style="color: red;">No se puede agregar/eliminar campos porque esta subcategoría tiene planes asociados y configurados bajo los campos ya seleccionados. Para editar los campos se deben desasociar los planes o eliminar los planes asociados.</p>

                    <p class="lead" style="margin-bottom: 0px">
                        Estos son los campos que se solicitarán al momento de la búsqueda de los planes asociados a esta subcategoría, para encontrar precisamente el plan adecuado a los datos ingresados en dichos campos.
                    </p>
                  </div>
                </div>
                <div class="row">
                    <div class="table-responsive">
                        <base-table class="table  mt-5"
                                    :data="features">
                            <template slot="columns">
                                <th class="text-center px-0 bg-transparent" scope="col">
                                <span class="text-light font-weight-700">Campo</span>
                                </th>
                                <th class="text-center bg-transparent" scope="col">Tipo de Campo </th>
                                <th class="text-center bg-transparent" scope="col">Tipo de Dato</th>
                                <th class="text-center bg-transparent" scope="col">Opciones de Datos</th>
                            </template>
                            
                            <template slot-scope="{row}">
                                <td class="text-center px-0">{{row.campo}}</td>
                                <td class="text-center" v-html="row.tipo_campo"></td>
                                <td class="text-center" v-html="row.tipo_dato"></td>
                                <td class="text-center" v-html="row.opciones_dato"></td>
                            </template>
                            
                        </base-table>
                    </div>
                </div>
            </card>
        </div>
      </div>
      -->
      <br>
      <!--
      <div
        class="form-row"
        v-for="(item, index) in atributosPlan"
        :key="index"
      >
        <div
            class="col-md-12"
            v-if="item.tipo_campo == 'ENUM'"
        >
            <base-input
                
                :label="item.nombre_identificatorio"
                v-model="atributosPlanModel[index]"
                :name="item.nombre_identificatorio"
                :error="getError(item.nombre_identificatorio)"
                v-validate="'required'"
            >
                <el-select  v-model="atributosPlanModel[index]" filterable
                            :placeholder="'Seleccione '+item.nombre_publico"
                            >
                    <el-option v-for="option in item.opciones"
                                :key="option"
                                :label="option"
                                :value="option">
                    </el-option>
                </el-select>
            </base-input>
        </div>
      </div>
      <br>
      -->
      <h2>Atributos del pricing</h2>
      <br>
      <div class="form-row" v-for="(item, index) in atributosPlan" :key="index+'-plan'">
        <div class="col-md-12">
          <base-input :label="item.nombre_publico" :name="item.nombre_publico" type="number" v-model="item.value" step="0.01" v-validate="{required: true}">
          </base-input>
        </div>
      </div>
      <br>
      <h2>Atributos de la materia</h2>
      <br>
      <div
        class="form-row"
        v-for="(item, index) in atributosMateria"
        :key="index"
      >
        <div
            class="col-md-12"
            v-if="item.momento == 'venta'"
        >
            <base-input
                v-if="item.regex"
                :label="item.nombre"
                v-model="atributosMateriaModel[index]"
                :name="item.nombre"
                :error="getError(item.nombre)"
                v-validate="{ required: true, regex: new RegExp(item.regex) }"
            >
            </base-input>
            <base-input
                v-else
                :label="item.nombre"
                v-model="atributosMateriaModel[index]"
                :name="item.nombre"
                :error="getError(item.nombre)"
                v-validate="'required'"
            >
            </base-input>
        </div>
      </div>
      <br>
      <h2>Atributos del cliente</h2>
      <br>
      <div
        class="form-row"
        v-for="(item, index) in atributosCliente"
        :key="index+'-Cliente'"
      >
        <div
            class="col-md-12"
        >
            <base-input
                :label="item.nombre"
                v-model="item.value"
                :name="item.nombre"
                :error="getError(item.nombre)"
                v-validate="{ required: true }"
            ></base-input>
        </div>
      </div>
      <br>
      <h2>Atributos del plan</h2>
      <br>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Prima" type="number" step="0.01" v-model="prima" v-validate="{required: true}">
          </base-input>
        </div>
      </div>
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formEditVenta">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
  import BaseTable from '@/components/BaseTable';
  
  import { Select, Option } from 'element-ui';
  export default {
    components: {
        
        [Select.name]: Select,
        [Option.name]: Option,
        BaseTable,
    },
    data() {
      return {
        validated: false,
        venta: {
            id: '',
          name: '',
        },
        model: {
          name: undefined,
          id: undefined,
          category: {
            value: undefined,
            name: undefined,
            id: undefined,
          }
        },
        fetchVenta: {
          id: '',

        },
        prima: 0.0,
        showModal: false,
        change_password: "0",
        reglasConfirmacion: '',
        reglasPassword: '',
        venta_id: null,
        permisos_editable: false,
        selectCategories: [],
        selectSearchablesAttributes: [],
        features: [],
        chosenFields: [],
        abilityEditSearchableattributes: true,

        atributosPlan: [],
        atributosMateria: [],

        atributosPlanModel: [],
        atributosMateriaModel: [],

        atributosCliente: [],
        atributosClienteModel: [],

      }
    },
    methods: {
      eventoEnter(evt){
          //console.log(evt);
          evt.stopPropagation();
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(evt){
        var vm = this;
        if(!parseFloat(this.prima)) return;
        if(this.atributosPlan.find(ap => ap.nombre_publico == 'el valor del equipo' && !parseFloat(ap.value))) return;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          
          if( response ){
            
            vm.axios({
                method: 'PUT',
                url: 'api/edit_venta',
                data: {   
                        venta: vm.fetchVenta.id,
                        atributosMateriaName: vm.atributosMateria,
                        atributosMateriaData: vm.atributosMateriaModel,
                        atributosCliente: vm.atributosCliente,
                        atributosPlan: vm.atributosPlan,
                        prima: parseFloat(vm.prima)
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Venta editada exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo modificar la venta',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
          
        }).catch( reason => {
          console.log(reason);
        });
      },
      fetchDataVenta(venta_id)
      {
        var vm = this;
        
        return this.axios({
            method: 'GET',
            url: 'api/edit_venta?venta='+venta_id
        }).then(response => {
            vm.fetchVenta.id = response.data.id;
            vm.prima = response.data.prima;
            vm.atributosPlan = [];
            vm.atributosPlan = response.data.atributos_plan.filter(ap => (['el valor del equipo']).includes(ap.nombre_publico)).map(ap => ({
              ...ap,
              value: parseFloat(ap.value)
            }));
            vm.atributosPlan.forEach( e => {
                vm.atributosPlanModel.push(undefined);
            });
            vm.atributosMateria = [];
            vm.atributosMateria = response.data.atributos_materia;
            vm.atributosMateria.forEach( e => {
                vm.atributosMateriaModel.push(e.value);
            });
            vm.atributosCliente = [];
            vm.atributosCliente = Object.keys(response.data.atributos_cliente).filter(key => (['dni','nombres','paterno','materno','email']).includes(key)).map(key => ({
              nombre: key,
              value: response.data.atributos_cliente[key],
            }));
            
            vm.showModal = true;
        }).catch( error => {
            console.log(error);
        })
        ;
      },
    },
    mounted()
    {
        
    },
    created()
    {
      var vm = this;
      this.$parent.$on('loadModalEditVenta', (venta_id) => { vm.fetchDataVenta(venta_id); } );
    },
  }
</script>
<style>
</style>
